import { render, staticRenderFns } from "./BlockSettingsPage.vue?vue&type=template&id=7c0d0f80&scoped=true"
import script from "./BlockSettingsPage.vue?vue&type=script&lang=js"
export * from "./BlockSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./BlockSettingsPage.vue?vue&type=style&index=0&id=7c0d0f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d0f80",
  null
  
)

export default component.exports